import { Modal } from './Modal';

export interface HelpModalProps {
  onClose: () => void;
}

/** "How to Play" -- objective, controls, power pellets, co-op, extra life.
 * Concise/scannable: short headings + short lines, no long paragraphs. */
export function HelpModal({ onClose }: HelpModalProps): JSX.Element {
  return (
    <Modal title="How to Play" onClose={onClose} className="help-modal" testId="help-modal">
      <section className="help-section">
        <h3>Objective</h3>
        {/* PART 6: "Highest score wins" was a leftover single-player framing
            -- there's no winner here, it's shared maze / independent lives
            and scores / team total on the leaderboard (see the Co-op
            section below). Reconciled to match that actual co-op framing. */}
        <p className="dim">Clear every dot in the maze together while dodging the ghosts.</p>
      </section>
      <section className="help-section">
        <h3>Controls</h3>
        <ul className="help-list">
          <li>
            <span className="caption">Desktop</span> Arrow keys or WASD to move, Esc to pause.
          </li>
          <li>
            <span className="caption">Mobile</span> On-screen joystick (default), or swipe anywhere on the maze.
            Switch to a D-pad, or change the control size, in Settings.
          </li>
        </ul>
      </section>
      <section className="help-section">
        <h3>Power pellets</h3>
        <p className="dim">Eat one to turn the ghosts frightened (and edible) for a short time. Eat them for bonus points before it wears off.</p>
      </section>
      <section className="help-section">
        <h3>Co-op</h3>
        <p className="dim">
          Share your team code with a friend to drop them into your maze. You each keep independent lives and
          scores, but share the same maze, dots, and ghosts. Clear it together.
        </p>
      </section>
      <section className="help-section">
        <h3>Extra life</h3>
        <p className="dim">Cross 10,000 points to earn one bonus life.</p>
      </section>
    </Modal>
  );
}
